import React, { useEffect, useState } from "react";
import profilepic from "../Assets/profile.png";
import { btn_style_if_admin, btn_style_if_not_admin } from "../Config";
import { postSmartSearch } from "../ApiServices/AuthService";
import Modal from "./Modal";
import { useNavigate } from "react-router-dom";
import Spinner from './Spinner'

const Navbar = ({ isAdmin , onSearchResults , onCross}) => {
  const [userProfile, setUserProfile] = useState(undefined);
  const [searchText, setSearchText] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);


  const navigate = useNavigate();

  const handleOpenModal = () => {
    setShowModal(true);
  };

  useEffect(()=>{
    if(localStorage.getItem('picture') !== undefined) {
        setUserProfile(localStorage.getItem('picture'));
    }else{
      setUserProfile('https://lh3.googleusercontent.com/a/ACg8ocLir7YJfGtYxgcNYEH74Z1_WIoWk4t60ViiXfofFVlMFQ=s96-c');
    }
},[])


  // Handle closing the modal
  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  function formatText(str) {
    // Special handling for MongoDB
    str = str.replace(/mongodb|mongoDb/gi, 'MongoDB');
  
    // Convert each word in the string
    return str.replace(/\w\S*/g, function(txt){
        // If word has already an uppercase letter, leave it unchanged
        if(/[A-Z]/.test(txt.slice(1))){
            return txt.charAt(0).toUpperCase() + txt.substr(1);
        }
        // Otherwise, capitalize the first letter and make the rest lowercase
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}


  const handleSearch = () => {
    if (searchText.trim() !== "") {
      setShowSpinner(true);
      let obj = {
        question : formatText(searchText.trim()),
      }
      postSmartSearch(obj).then((res) => {
        onSearchResults(res.data);
      }) .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setShowSpinner(false);
      });
    }
  };

  return (
    <div className="navbar">
      {showSpinner && <Spinner />}
      <div className="logo">
        <h1>LOGO</h1>
      </div>
      <div className="nav-items">
        <div className="search">
          <i className="fa-solid fa-magnifying-glass" id="search-icon"></i>
          <input
            className="search-input"
            type="text"
            placeholder="Search..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyDown={handleKeyDown}
          />
          {searchText && (
            <i
              className="fa-solid fa-x"
              id="cross-icon"
              onClick={() => {
                onCross();
                setSearchText("")
              } }
            />
          )}
        </div>
        <div className="btn-profile">
          <button
            className="add-project-btn"
            style={isAdmin ? btn_style_if_admin : btn_style_if_not_admin}
            onClick={handleOpenModal}
          >
            Add Project
          </button>
          <div className="profile-image" onClick={() => {
            if(window.confirm("Do you want to logout?")){
                localStorage.clear();
                navigate('/');
            }
        }}>
          <img src={"https://lh3.googleusercontent.com/a/ACg8ocLir7YJfGtYxgcNYEH74Z1_WIoWk4t60ViiXfofFVlMFQ=s96-c"} alt="profile" />
          </div>
        </div>
      </div>
      <Modal show={showModal} onClose={handleCloseModal} onCross = {onCross}/>
    </div>
  );
};

export default Navbar;
